/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { smoothScrollTo } from "./smoothScrollTo";
import { scrollToTopBtn } from "./smoothScrollToTopBtn";
import { setDNavBtn } from "./setDNavBtn";
import { setHeaderTransform } from "./setHeaderTransform";
import { setSplash } from "./setSplash";
import { setAcdnMenu } from "./setAcdnMenu";
import { setScrollTrigger } from "./setScrollTrigger";

/**
 * Do modules.
 */
function modules() {
	smoothScrollTo();
	scrollToTopBtn();
	setDNavBtn();
	setHeaderTransform();
	// setSplash();
	setScrollTrigger();
	setAcdnMenu();
}

export { modules };
